<template>
  <div class="modal fade" :class="{ show: isShow }">
    <div class="modal-dialog modal-dialog-centered" :class="sizeClass" ref="dialog" role="dialog">
      <div data-testid="div-modal-wnd" class="modal-content">
        <div data-testid="div-modal-header" class="modal-header">
          <h4 data-testid="div-modal-title" class="modal-title">
            <slot name="header"></slot>
          </h4>
          <span class="modal-header-close icon icon-close icon_small" @click="close"></span>
        </div>
        <div class="modal-body">
          <slot name="body"></slot>
        </div>
        <div class="modal-footer" :class="{ 'justify-content-between': isModeConfirm || isModeReverse }">
          <slot name="footer">
            <template v-if="isModeConfirm">
              <button class="btn btn-primary" @click="confirm" data-testid="btn-yes" type="button">
                <slot name="yes">{{ $t('button.yes') }}</slot>
              </button>
              <button class="btn btn-danger" @click="cancel" data-testid="btn-no" type="button">
                <slot name="no">{{ $t('button.no') }}</slot>
              </button>
            </template>
            <template v-else-if="isModeReverse">
              <button class="btn btn-danger" @click="cancel" data-testid="btn-no" type="button">
                <slot name="no">{{ $t('button.reset') }}</slot>
              </button>
              <button class="btn btn-primary" @click="confirm" type="button">
                <slot name="yes">{{ $t('button.apply') }}</slot>
              </button>
            </template>
            <button v-else-if="isModeApply" class="btn btn-primary" data-testid="btn-apply-changes" @click="confirm" type="button">
              <slot name="yes">{{ $t('button.apply') }}</slot>
            </button>
            <button v-else class="btn btn-dark" @click="close" type="button">
              <slot name="close">{{ $t('button.ok') }}</slot>
            </button>
          </slot>
        </div>
        <div>
          <slot name="extra"></slot>
        </div>
      </div>
    </div>

    <div class="modal-backdrop fade" :class="{ show: isShow }" @click="clickOutside"></div>
  </div>
</template>

<script>
import('@/styles/components/modal.less')

export default {
  name: 'BaseModal',
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    mode: {
      type: String,
      default: 'confirm'
    },
    size: {
      type: String,
      required: false
    },
    isDisabledBtn: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isModeConfirm() {
      return this.mode === 'confirm'
    },
    isModeApply() {
      return this.mode === 'apply'
    },
    isModeReverse() {
      return this.mode === 'reverse'
    },
    sizeClass() {
      if (!this.size) {
        return ''
      }
      return `modal-${this.size}`
    }
  },
  watch: {
    isShow() {
      if (this.isShow) {
        this.$refs.dialog.focus()
      }
    }
  },
  mounted() {
    this.$root.$on('keydown:enter', this.onEnterHandler)
    this.$root.$on('keydown:esc', this.onEscHandler)
  },
  methods: {
    clickOutside(e) {
      if (e.target.closest('.modal-dialog') === this.$refs.dialog) {
        return
      }
      this.close()
    },
    close() {
      if (!this.isDisabledBtn) {
        this.$emit('close')
      }
    },
    confirm() {
      if (!this.isDisabledBtn) {
        this.$emit('confirm')
      }
    },
    cancel() {
      this.$emit('cancel')
    },
    onEnterHandler() {
      if (this.isShow) {
        this.confirm()
      }
    },
    onEscHandler() {
      if (this.isShow) {
        this.close()
      }
    }
  }
}
</script>
